// adminApiRouter.js 對應後端 BackAdminApiRouter
import service from './service'

export default {
	//公告管理
	announcement: {
		add: params => service.post(`/back/admin/announcement/add`, params),
		contractSchemeList: () =>
			service.get(`/back/admin/announcement/contractSchemeList`),
		contractStatusList: () =>
			service.get(`/back/admin/announcement/contractStatusList`),
		delete: params =>
			service.delete(`/back/admin/announcement/delete`, { params }),
		get: params => service.get(`/back/admin/announcement/get`, { params }),
		page: params => service.post(`/back/admin/announcement/page`, params),
		storeList: params =>
			service.post(`/back/admin/announcement/storeList`, params),
		templateList: () => service.get(`/back/admin/announcement/templateList`),
		update: params => service.put(`/back/admin/announcement/update`, params),
	},

	// 公告範本管理
	announcementTemplate: {
		add: params => service.post(`/back/admin/announcementTemplate/add`, params),
		delete: params =>
			service.delete(`/back/admin/announcementTemplate/delete`, { params }),
		get: params =>
			service.get(`/back/admin/announcementTemplate/get`, { params }),
		page: params =>
			service.post(`/back/admin/announcementTemplate/page`, params),
		update: params =>
			service.put(`/back/admin/announcementTemplate/update`, params),
		updateSort: params =>
			service.put(`/back/admin/announcementTemplate/updateSort`, params),
	},

	// 店家管理
	store: {
		exportExcel: params =>
			service.post(`/back/admin/store/export`, params, {
				responseType: 'blob',
			}),
		exportMenu: data =>
			service.post(`/back/admin/store/exportMenu`, data, {
				responseType: 'blob',
				returnRawResponse: true,
			}),
		importMenu: formData =>
			service.post(`/back/admin/store/importMenu`, formData),
	},

	// 業務管理
	sales: {
		exportExcel: params =>
			service.post(`/back/admin/sales/export`, params, {
				responseType: 'blob',
			}),
	},

	// 檔案
	file: {
		downloadFile: params =>
			service.get(`/back/admin/file/download/${params}`, {
				responseType: 'blob',
			}),
	},

	// 合約管理
	contract: {
		getContractExpire: () => service.get(`/back/admin/contract/expire`),
		createContract: params =>
			service.post(`/back/admin/contract/add`, params, {
				headers: { 'Content-Type': 'multipart/form-data' },
			}),
		updateContract: params =>
			service.put(`/back/admin/contract/update`, params, {
				headers: { 'Content-Type': 'multipart/form-data' },
			}),
		deleteContract: params =>
			service.delete(`/back/admin/contract/delete`, { params }),
		getContract: params => service.get(`/back/admin/contract/get`, { params }),
		getContractPage: params =>
			service.post(`/back/admin/contract/page`, params),
		getContractPlanList: () => service.get(`/back/admin/contract/planList`),
		getContractSchemeSimpleList: params =>
			service.get(`/back/admin/contract/schemeSimpleList`, { params }),
		getContractSystemSchemeSimpleList: params =>
			service.get(`/back/admin/contract/systemSchemeSimpleList`, { params }),
		getContractScheme: params =>
			service.get(`/back/admin/contract/scheme`, { params }),
	},

	// 合約方案管理
	scheme: {
		createScheme: params => service.post(`/back/admin/scheme/add`, params),
		updateScheme: params => service.put(`/back/admin/scheme/update`, params),
		deleteScheme: params =>
			service.delete(`/back/admin/scheme/delete`, { params }),
		getScheme: params => service.get(`/back/admin/scheme/get`, { params }),
		getSchemePage: params => service.post(`/back/admin/scheme/page`, params),
		getSchemeStoreList: params =>
			service.get(`/back/admin/scheme/storeList`, { params }),
		uploadSchemeFile: params =>
			service.post(`/back/admin/scheme/upload`, params, {
				headers: { 'Content-Type': 'multipart/form-data' },
			}),
	},

	// 系統設定
	systemSetting: {
		getList: () => service.get(`/back/admin/platformParam/list`),
		update: params => service.put(`/back/admin/platformParam/update`, params),
	},
}
